import * as React from 'react';
import {
  Button,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Input,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';

import {Formik} from 'formik';
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
  DateTimePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {
  convertPersianDigit2English,
  checkMatchMedia,
  removeEmptyValueObject,
  flattenObject,
  OrderTransportationType,
  dictionaryKeyStrings,
  translate,
} from './helpers';
import {Status as OrderStatus} from '../pages/orders/interfaces';
import {
  Status as BundleStatus,
  OrderBundleStatus,
} from '../pages/bundles/interfaces';
import {Status as CenterStatus} from '../pages/centers/interfaces';
import {Status as ParcelsState} from '../pages/parcels/interfaces';
import {UserRole} from '../pages/users/interfaces';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {Category} from '../pages/products/interfaces';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
      '& .MuiSelect-root': {
        fontSize: '1rem !important',
      },
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    inputWrapper: {
      flex: 7,
    },
    icon: {
      color: '#8a8a8a',
    },
  })
);

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

export type State = {
  classes: Function;
};
export type Props = {
  filters: Filter[];
  onFilter: any; //ToDo
  setOpenFilterBox?: any;
};

export type Filter = {
  type:
    | 'input'
    | 'select'
    | 'checkbox'
    | 'date-picker'
    | 'number'
    | 'time-picker'
    | 'date-picker-time';
  id: string;
  label: string;
  placeholder?: string;
  data?:
    | OrderStatus[]
    | BundleStatus[]
    | UserRole[]
    | CenterStatus[]
    | ParcelsState[]
    | OrderTransportationType[]
    | OrderBundleStatus[]
    | Category[];
  translateType?: dictionaryKeyStrings
  icon?: any;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class RenderFilters extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = {
      checkboxValue: [],
      init: {},
    };
  }

  handleSubmit = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
  };
  handleChange = (event: React.ChangeEvent<{value: unknown}>) => {
    this.setState({
      checkboxValue: event.target.value as string,
    });
  };

  renderFromItems = (filters: Record<string, any>[], props: any) => {
    const classes = useStyles();
    return filters.map(
      (
        item: any, //todo type
        index: number
      ) => (
        <Grid
          className={classes.root}
          container
          item
          spacing={2}
          xs={12}
          sm={6}
          key={index}
        >
          {(item.type === 'input' ||
            item.type === 'number' ||
            item.type === 'date-picker' ||
            'date-picker-time' ||
            item.type === 'checkbox' ||
            (item.type === 'select' && item.icon)) &&
            item.icon && (
              <Grid
                item
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <Icon path={item.icon} size={1} className={classes.icon} />
              </Grid>
            )}
          {item.type === 'input' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                name={item.id}
                label={item.label}
                fullWidth
                defaultValue={null}
                className={classes.textInput}
                value={props.values[item.id] || null}
                onChange={props.handleChange}
              />
            </Grid>
          )}

          {item.type === 'number' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                name={item.id}
                label={item.label}
                type={item.type}
                className={classes.textInput}
                fullWidth
                value={props.values[item.id] || null}
                onChange={props.handleChange}
              />
            </Grid>
          )}

          {item.type === 'date-picker' && (
            <Grid item className={classes.inputWrapper}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  fullWidth
                  autoOk
                  variant="inline"
                  label={item.label}
                  format="YYYY/MM/DD"
                  className={classes.textInput}
                  clearable
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={date =>
                    date?.isValid() ? date.format('jYYYY/jMM/jDD') : ''
                  }
                  value={props.values[item.id] || null}
                  name={item.id}
                  id={item.id}
                  onChange={value => {
                    return props.setFieldValue(
                      [item.id],
                      value &&
                        convertPersianDigit2English(value.format('YYYY-MM-DD'))
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {item.type === 'date-picker-time' && (
            <Grid item className={classes.inputWrapper}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DateTimePicker
                  fullWidth
                  label={item.label}
                  variant="inline"
                  format="YYYY/MM/DD HH:mm"
                  className={classes.textInput}
                  autoOk
                  clearable
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={date =>
                    date?.isValid() ? date.format('jYYYY/jMM/jDD HH:mm') : ''
                  }
                  value={props.values[item.id] || null}
                  name={item.id}
                  id={item.id}
                  onChange={value => {
                    return props.setFieldValue(
                      [item.id],
                      value && convertPersianDigit2English(value.format())
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {item.type === 'time-picker' && (
            <Grid item className={classes.inputWrapper}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <TimePicker
                  fullWidth
                  label={item.label}
                  variant="inline"
                  ampm={false}
                  format="HH:mm"
                  className={classes.textInput}
                  autoOk
                  clearable
                  labelFunc={date =>
                    date?.isValid() ? date.format('HH:mm') : ''
                  }
                  value={props.values[item.id] || null}
                  name={item.id}
                  id={item.id}
                  onChange={value => {
                    return props.setFieldValue(
                      [item.id],
                      value &&
                        convertPersianDigit2English(
                          value.format('jYYYY/jMM/jDD HH:mm')
                        )
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {item.type === 'select' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{width: '100%'}}>
                <InputLabel htmlFor={item.id}>{item.label}</InputLabel>
                <Select
                  fullWidth
                  className={classes.textInput}
                  name={item.id}
                  inputProps={{
                    name: item.id,
                    id: item.id,
                  }}
                  value={props.values[item.id]}
                  onChange={props.handleChange}
                >
                  {item.data.map((itemD: any, index: number) => (
                    <MenuItem value={itemD} key={index}>
                      {translate(itemD, item.translateType)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {item.type === 'checkbox' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{width: '100%'}}>
                <InputLabel id={item.id}>{item.label}</InputLabel>
                <Select
                  labelId={item.id}
                  id={item.id}
                  className={classes.textInput}
                  multiple
                  onChange={e => {
                    this.handleChange(e);
                    props.handleChange(e);
                  }}
                  value={this.state.checkboxValue}
                  input={<Input />}
                  name={item.id}
                  inputProps={{
                    name: item.id,
                    id: item.id,
                  }}
                  renderValue={(selected: any) => {
                    const nameSelectedItem = item.data.filter((status: any) => {
                      return selected.includes(status);
                    });

                    return nameSelectedItem
                      .map((nameSelect: any) =>
                        translate(nameSelect, item.translateType)
                      )
                      .join(',');
                  }}
                  MenuProps={MenuProps}
                >
                  {item.data.map((itemD: any) => (
                    <MenuItem key={itemD} value={itemD}>
                      <Checkbox
                        checked={this.state.checkboxValue.indexOf(itemD) > -1}
                      />
                      <ListItemText
                        primary={
                          translate(itemD, item.translateType)
                        }
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      )
    );
  };

  clearForm = (props?: any) => {
    this.setState({checkboxValue: []});
    this.props.onFilter({});
  };

  renderInitialValues = (items: Filter[]) => {
    const initialValues: any = {};
    items.map((filter: Filter) => (initialValues[filter.id] = null));
    this.setState({init: initialValues});
  };

  render() {
    const {filters, onFilter} = this.props;
    return (
      <div>
        <Formik initialValues={this.state.init} onSubmit={onFilter}>
          {(props: {
            handleSubmit: any;
            values: any;
            handleReset: any;
            handleChange: any;
            resetForm: any;
            setValues: any;
          }) => {
            const formLength = Object.keys(
              removeEmptyValueObject(flattenObject(props.values))
            ).length;
            const primaryButton = {
              backgroundColor: formLength !== 0 ? '#dfa01f' : '#b3b3b3',
              color: 'white',
            };
            const secondaryButton = {
              backgroundColor: formLength !== 0 ? '#b3b3b3' : 'transparent',
              color: formLength !== 0 ? 'white' : '#c9c9c9',
              boxShadow: formLength !== 0 ? '' : 'none',
            };
            return (
              <form onSubmit={props.handleSubmit}>
                <Grid
                  container
                  spacing={checkMatchMedia('(max-width: 768px)') ? 1 : 3}
                >
                  {this.renderFromItems(filters, props)}
                  <Grid
                    xs={12}
                    sm={12}
                    item
                    style={{
                      display: 'flex',
                      marginTop: '20px',
                      marginBottom: '20px',
                      marginRight: 'auto',
                    }}
                  >
                    <div style={{display: 'flex', flexGrow: 1}} />

                    <div style={{padding: '0 5px'}}>
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        style={secondaryButton}
                        disabled={formLength === 0}
                        onClick={() => {
                          onFilter({});
                          this.props.setOpenFilterBox &&
                            this.props.setOpenFilterBox(false);
                          setTimeout(
                            // Shet Code
                            () =>
                              this.props.setOpenFilterBox &&
                              this.props.setOpenFilterBox(true),
                            1000
                          );
                        }}
                      >
                        {'پاک ‌کردن فرم '}
                      </Button>
                    </div>
                    <div style={{padding: '0 5px'}}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        size="large"
                        style={primaryButton}
                        data-cy="search"
                        disabled={formLength === 0}
                      >
                        {'جستجو'}
                        {false}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </div>
    );
  }
}

export default RenderFilters;
